import { apiFetch } from './interceptor';
const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/v1';

export const transactionsApi = {
    getTransactions: async (token, page, limit, drawDate, gameId, drawTime, search, type) => {
        const response = await apiFetch(`${BASE_URL}/transactions?page=${page}&limit=${limit}&drawDate=${drawDate}&gameId=${gameId}&drawTime=${drawTime}&search=${search}&type=${type}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }); 
        const data = await response.json();
        return { status: response.status, data };
    },

    getTransactionById: async (token, id) => {
        const response = await apiFetch(`${BASE_URL}/transactions/${id}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        const data = await response.json();
        return { status: response.status, data };
    }
}
